import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  UncontrolledDropdown,
  Row,
  Col,
  Progress,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupButtonDropdown,
  Button,
  ButtonGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import styles from "./style.module.scss";
import { addDay, addMonth, DateField, toFormatDate } from "../../../utils";
import CounterParty from "../CounterPartySet/CounterParty";
import Autosuggest from "../../Autosuggest/Autosuggest";
import GridCounterParty from "./grids/GridCounterParty";
import GridCustodian from "./grids/GridCustodian";
import { ChartsCounterParty } from "./grids/ChartCounterPartyFailling";
import CircularProgress from "../../CircularProgress/CircularProgress";

const initialState = {
  dropdownMonthOpen: false,
  counterparties: [],
  loadingCP: true,
  custodians: [],
  loadingCU: true,
  loadingGP: true,
  topMonthSelected: 10,
  faillings: [],
  selectedCP: {
    id: 0,
    name: undefined,
  },
  selectedCU: {
    id: 0,
    name: undefined,
  },
  counterpartiesSuggested: [],
  searchBar: "",
  fromDate: addMonth(new Date(), -1).toLocaleDateString("en"),
  toDate: addDay(new Date(), 5).toLocaleDateString("en"),
  openCounterParty: false,
  loadingCountry: false,
  countries: [],
  clearinghouses: [],
  countriesloading: false,
  clearinghousesloading: false,
};

const CounterPartyRanking = ({ fetchs, callApiProxy, Flag, AddNew }) => {
  const [state, setState] = useState(initialState);
  const [graphicdata, setGraphicdata] = useState([]);

  const CounterPartyForm = () => {
    setState({
      ...state,
      openCounterParty: true,
      loadingCountry: true,
      countriesloading: true,
      clearinghousesloading: true,
    });
    fetchs.getCountryCounterParty().then((r) => {
      setState({
        ...state,
        openCounterParty: true,
        countries: r.countries,
        countriesloading: false,
      });
    });
    fetchs.getClearingHouseCounterParty().then((c) => {
      setState({
        ...state,
        openCounterParty: true,
        clearinghouses: c.clearingHouses,
        clearinghousesloading: false,
      });
    });
  };

  useEffect(() => {
    setState({
      ...state,
      loadingCP: true,
    });
    fetchs
      .fetchCounterPartyRank({
        page: state.topMonthSelected,
        id: state.selectedCP.id,
      })
      .then((r) => {
        setState({
          ...state,
          loadingCP: false,
          counterparties: r.response.collection,

          selectedCU: {
            id:
              state.selectedCP.id ||
              (r.response.collection.length > 0 && r.response.collection[0].Id
                ? r.response.collection[0].Id
                : 0),
            name: (r.response.collection[0] && r.response.collection[0].Name) || undefined,
          },
        });
      });
  }, [state.topMonthSelected, state.selectedCP.id]);

  const handleChangeTop = (newTop) => {
    setState({
      ...state,
      topMonthSelected: newTop,
    });
  };

  useEffect(() => {
    setState({
      ...state,
      loadingCU: true,
    });
    fetchs
      .fetchCounterPartyTrades({
        counterParty: state.selectedCU.id,
        from: toFormatDate(state.fromDate),
        to: toFormatDate(state.toDate),
      })
      .then((r) => {
        setState({
          ...state,
          custodians: r.response.trades,
          loadingCU: false,
        });
      });
  }, [state.selectedCU.id, state.fromDate, state.toDate]);

  const handleSelectCounterParty = (id, name) => {
    setState({
      ...state,
      selectedCU: {
        id: id,
        name: name,
      },
    });
  };

  useEffect(() => {
    let date = new Date();
    let day = date.getDate() - 1;
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    const fecha = year + "-" + month + "-" + day;
    fetchs.getMostFaillings({ date: fecha }).then((r) => {
      setGraphicdata(r);
    });
  }, []);

  const getSuggestionValue = (suggestion) => {
    return suggestion.name;
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    return fetchs.fetchAutoSuggestCounterParty({ name: value }).then((response) => {
      const suggestions = [];
      if (response && response.response && response.response.suggestions) {
        response.response.suggestions.map((s) => {
          suggestions.push({
            id: s.Id,
            name: s.Name,
          });
        });
      }
      return suggestions;
    });
  };

  const renderSuggestion = (suggestion) => (
    <div
      style={{
        display: "inline-block",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "100%",
      }}
    >
      {suggestion.name}
    </div>
  );

  const handleSelectSearchCounterParty = (m, value) => {
    if (value == "") {
      setState({
        ...state,
        topMonthSelected: 20,
        selectedCP: {
          ...state.selectedCP,
          id: 0,
        },
      });
    } else {
      if (m != "type" && value.id) {
        setState({
          ...state,
          selectedCP: {
            ...state.selectedCP,
            id: value.id,
          },
        });
      }
    }
  };

  const handleChangeRange = (name, value) => {
    setState({
      ...state,
      [name]: value,
    });
  };

  const onClickClose = () => {
    setState({
      ...state,
      openCounterParty: false,
    });
  };

  return (
    <div>
      {state.openCounterParty && (
        <CounterParty
          open={state.openCounterParty}
          countries={state.countries}
          clearinghouses={state.clearinghouses}
          onClickClose={onClickClose.bind(this)}
          callApiProxy={callApiProxy}
          countriesloading={state.countriesloading}
          clearinghousesloading={state.clearinghousesloading}
          editCounterParty={false}
          counterPartyId={0}
        />
      )}
      <div className={styles.toolbar}>
        <Row>
          <Col>
            <InputGroup style={{ marginLeft: "10%" }}>
              <InputGroupAddon addonType="prepend">
                <button className="btn btn-secondary" type="button">
                  <i className="fa fa-search"></i>
                </button>
              </InputGroupAddon>

              <Autosuggest
                suggestions={state.counterpartiesSuggested}
                onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={renderSuggestion}
                value={state.searchBar}
                inputProps={{
                  placeholder: "Search CounterParty...",
                }}
                onChange={(m, v) => handleSelectSearchCounterParty(m, v)}
              />
            </InputGroup>
          </Col>
          <Col className="text-center">
            <UncontrolledDropdown>
              <DropdownToggle caret>Top {state.topMonthSelected}</DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleChangeTop(20)}>Top 20 month</DropdownItem>
                <DropdownItem onClick={() => handleChangeTop(10)}>Top 10 month</DropdownItem>
                <DropdownItem onClick={() => handleChangeTop(5)}>Top 5 month</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Col>
          <Col>
            <div className="float-right">
              { !(AddNew) ?
              <ButtonGroup>
              </ButtonGroup> : (
                <ButtonGroup>
                <Button color="primary" className="float-right" onClick={CounterPartyForm}>
                  <i className="fa fa-plus"></i> Add new
                </Button>
              </ButtonGroup>
              )}
            </div>
          </Col>
        </Row>
      </div>

      <Row>
        {graphicdata.length < 1 ? (
          <CircularProgress />
        ) : (
          <Col colSpan={12}>
            <Card>
              <CardBody>
                <ChartsCounterParty data={graphicdata} />
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
      <Row>
        <Col colSpan={6}>
          <Card>
            <CardBody>
              <Label>
                <strong>Showing Top {state.topMonthSelected}</strong>
              </Label>
              <GridCounterParty
                rows={state.counterparties}
                loading={state.loadingCP}
                selectedCP={state.selectedCP.id}
                selectCP={handleSelectCounterParty}
                Flag={Flag}
                callApiProxy={callApiProxy}
                fetchs={fetchs}
              />
            </CardBody>
          </Card>
        </Col>
        <Col colSpan={6}>
          <Card>
            <CardBody>
              <Form inline>
                <Label style={{ marginRight: 5 }}>From</Label>
                <DateField
                  id="from"
                  label=""
                  name="fromDate"
                  onChange={(name, value) => handleChangeRange(name, value)}
                  value={state.fromDate}
                />
                <InputGroup>
                  <InputGroupAddon addonType="append">
                    <button className="btn btn-secondary" type="button">
                      <i className="fa fa-calendar"></i>
                    </button>
                  </InputGroupAddon>
                </InputGroup>{" "}
                <Label style={{ marginLeft: 10, marginRight: 5 }}>To</Label>
                <DateField
                  id="to"
                  label=""
                  name="toDate"
                  onChange={(name, value) => handleChangeRange(name, value)}
                  value={state.toDate}
                />
                <InputGroup>
                  <InputGroupAddon addonType="append">
                    <button className="btn btn-secondary" type="button">
                      <i className="fa fa-calendar"></i>
                    </button>
                  </InputGroupAddon>
                </InputGroup>
              </Form>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Label>
                <strong>{state.selectedCU.name} Trades</strong>
              </Label>
              <GridCustodian rows={state.custodians} loading={state.loadingCU} Flag={Flag} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CounterPartyRanking;
